import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class DocumentTitle {
    private internalTitle!: string;

    public get title(): string {
        return `${this.internalTitle} - Subiekt 123`;
    }

    public set(value: string): void {
        this.internalTitle = value;
        document.title = this.title;
    }
}
